import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {API_VERSIONS} from '../api-versions';
import {UserProfileModel} from './models/user-profile.model';
import {AuthorizationModel} from './models/authorization-model';
import {UserModel} from './models/user.model';
import {LoginModel} from "../../shared/models/login.model";
import {TokenResponse} from "../../shared/models/token-response";
import {catchError, map} from "rxjs/operators";

const API_AUTH_URL = `${environment.apiUrl}/${API_VERSIONS.V1}/authorization`;

const login = `${API_AUTH_URL}/login`;
const token = `${API_AUTH_URL}/token`;
const register = `${API_AUTH_URL}/register`;
const editProfile = `${API_AUTH_URL}/editprofile`;
const forgotPassword = `${API_AUTH_URL}/forgot-password`;
const getProfile = `${API_AUTH_URL}/getprofile`;
const changePassword = `${API_AUTH_URL}/changepassword`;
const editProfileImage = `${API_AUTH_URL}/editprofileimage`;
const getUsers = `${API_AUTH_URL}/getallusers`;
const deleteUser = `${API_AUTH_URL}/deleteuser`;
const getRoles = `${API_AUTH_URL}/getallroles`;
const deleteRole = `${API_AUTH_URL}/deleterole`;
const createRole = `${API_AUTH_URL}/createrole`;
const updateRole = `${API_AUTH_URL}/updaterole`;

@Injectable({
    providedIn: 'root',
})
export class AuthorizationService {
    constructor(private client: HttpClient) {
    }

  getToken(userLogin: LoginModel): Observable<TokenResponse> {
    let params = new HttpParams();
    params = params.append('Username', userLogin.email);
    params = params.append('Password', userLogin.password);
    return this.client.post<TokenResponse>(token, {}, {params}).pipe(
      map((response) => {
        return new TokenResponse(response);
      }),
      catchError((error) => throwError(error))
    );
  }

  login(userLogin: LoginModel, token: string): Observable<any> {
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}` });
    return this.client.post<any>(login, {email: userLogin.email, password: userLogin.password}, {headers});
  }

    register(user: AuthorizationModel): Observable<AuthorizationModel> {
        return this.client.post<AuthorizationModel>(register, user);
    }

    editProfile(accountInfo: UserProfileModel): Observable<UserProfileModel> {
        return this.client.post<UserProfileModel>(editProfile, accountInfo);
    }

    forgotPassword(email: string): Observable<boolean> {
        return this.client.post<boolean>(forgotPassword, {
            email,
        });
    }

    getProfile(email: string): Observable<UserProfileModel> {
        return this.client.post<UserProfileModel>(getProfile, {
            email,
        });
    }

    changePassword(
        userId: string,
        email: string,
        password: string,
        newPassword: string
    ): Observable<any> {
        return this.client.post(changePassword, {
            userId,
            email,
            password,
            newPassword,
        });
    }

    editProfileImage(id: string, image: File): Observable<any> {
        const fd = new FormData();
        fd.append('image', image);
        return this.client.post(editProfileImage, {
            id,
            image,
        });
    }

    getIdentityUsers(): Observable<UserModel[]> {
        return this.client.get<UserModel[]>(getUsers);
    }

    deleteIdentityUser(userId: string): Observable<UserModel> {
        return this.client.post<UserModel>(deleteUser, {userId});
    }

    getIdentityRoles(): Observable<Object> {
        return this.client.get(getRoles);
    }

    createRole(name: string): Observable<Object> {
        return this.client.post(createRole, {name})
    }

    deleteIdentityRole(id: string): Observable<Object> {
        return this.client.post(deleteRole, {id})
    }

    editIdentityRole(id: any, name: any): Observable<Object> {
        return this.client.post(updateRole, {id, name})
    }

}
